import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { UiTextField } from 'ui-components';

export function DaysAgo({ daysAgo, isDisabled, handleDaysAgoChange, maxDay }) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!isDisabled) handleDaysAgoChange(daysAgo);
  }, [isDisabled]);

  const handleInputChange = (e) => {
    const value = parseInt(e.target.value);
    if (value < 1) {
      handleDaysAgoChange(1);
    } else if (value > maxDay) {
      handleDaysAgoChange(maxDay);
    } else if (value.isNaN || !value) {
      handleDaysAgoChange(1);
    } else {
      handleDaysAgoChange(value);
    }
  };

  return (
    <div
      className='days-ago'
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer',
      }}
    >
      <UiTextField
        style={{
          width: '64px',
        }}
        disabled={isDisabled}
        placeholder=''
        value={daysAgo}
        onChange={handleInputChange}
        inputProps={{
          'data-testid': 'days-ago-date-picker',
          type: 'number',
          min: 1,
          max: maxDay,
        }}
      />
      <span className='text'>{t('common:daysAgo')}</span>
    </div>
  );
}

DaysAgo.propTypes = {
  isDisabled: PropTypes.bool,
  handleDaysAgoChange: PropTypes.func,
  maxDay: PropTypes.number,
  daysAgo: PropTypes.number,
};
